<template>
  <h3>Денежные Потоки (ДП) по прямому бизнесу</h3>
  <p>В ПО доступны расчеты денежных потоков ОВТ и ООЧП на основе годовых и месячных потоков, по прямому бизнесу и исходящему перестрахованию.</p>
  <div class="block">
    <h5>Логика при загрузке</h5>
    <p>Для того, чтобы иметь возможность произвести расчет денежных потоков в ПО на отчетную дату требуется загрузить:</p>
    <ul>
      <li>Загрузку для расчета резерва убытков на отчетную дату;</li>
      <li>Загрузочные файлы по ДП (ООЧП или ОВТ) на основе годовых и (или) месячных потоков.</li>
    </ul>
    <p>При соблюдении этих двух требований на отчетную дату создается расчет денежных потоков по 5 сущностям:</p>
    <ul>
      <li>Оплаченные убытки</li>
      <li>РУУ (косвенные)</li>
      <li>РУУ (прямые)</li>
      <li>РУУ (судебные)</li>
      <li>РУУ (ПВУ)</li>
    </ul>
    <p>Для подготовки ДП по вышеупомянутым РУУ необходимо указать долю в убытках для каждого из РУУ в разделе «Наилучшие оценки» (смотри <a href="">«Наилучшие оценки»</a>).</p>
    <p>По всем другим сущностям требуется провести расчеты по наилучшим оценкам по соответствующим сущностям для проведения расчетов. Дополнительно денежные потоки могут быть подготовлены по следующим сущностям:</p>
    <ul>
      <li>Возникновение прав на регрессы</li>
      <li>Возникновение прав на ГОТС</li>
      <li>Расходы по разнице первых требований и возмещений от РСА</li>
      <li>Нулевые требования</li>
    </ul>
    <p>В каждом разделе ДП доступна кнопка «Рассчитать все», которая позволяет провести расчеты по всем созданным сущностям, за исключением шаблона. Расчет шаблона производится отдельно.</p>
  </div>
  <div class="block">
    <h5>ДП ООЧП (по прямому бизнесу)</h5>
    <h6>Годовые ДП ООЧП</h6>
    <p>1. Прогноз в заработанной премии</p>
    <p>Перед таблицами с расчетами на интерфейсе указаны версия расчета и Прогноз в заработанной премии из загрузочного файла.</p>
    <img src="@/assets/img/guide/forecast-premium.png" alt="" srcset="">
    <p>Для остальных сущностей в начале каждого раздела отражается прогноз состоявшихся убытков вместо прогноза выручки, который считается на основе прогноза выручки из загрузки и коэффициентов убыточности по когортам из оплаченных убытков.</p>
    <img src="@/assets/img/guide/loss-forecast.png" alt="" srcset="">
    <p>2. Коэффициенты убыточности</p>
    <p>Далее в расчетах по оплаченным убыткам рассчитываются коэффициенты убыточности по когорте. 
      Для данных расчетов используется Заработная премия и окончательная убыточность из РУ из раздела «Наилучшие оценки».
    </p>
    <p>Пользователь может выбрать коэффициент убыточности по каждому периоду для каждой когорты, которая есть в загрузке для ДП ООЧП. Доступны следующие опции:</p>
    <ul>
      <li>Средний за последний год <i>(4 квартала)</i></li>
      <li>Средний за последние два года <i>(8 кварталов)</i></li>
      <li>Средний за последний год из итогового РУ</li>
      <li>Андеррайтинговый КУ из загрузки (используется загрузочный лист, где «Тип данных» является одним из следующих значений: «андеррайтинговые коэффициенты убыточности (для оплаченных убытков)», «андеррайтинговые коэффициенты убыточности (для урег. нул. треб.)», «андеррайтинговые коэффициенты убыточности (для расходов по разнице первичных требований и возмещений от РСА)».)</li>
      <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/dp-coef-loss.png" alt="" srcset="">
    <p>Для других сущностей рассчитывается «Выбор доли, %». В данную таблицу выгружаются методы, созданные в разделе «Наилучшие оценки» для каждой сущности. Для выбора коэффициентов доступны следующие опции:</p>
    <ul>
      <li>Средний за последний год <i>(4 квартала)</i></li>
      <li>Средний за последние два года <i>(8 кварталов)</i></li>
      <li>За последний квартал</li>
      <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/dp-rruu-choose.png" alt="" srcset="">
    <p>3. Выбор паттерна</p>
    <p>Далее для всех сущностей выбирается паттерн, который рассчитывается с помощью факторов развития РУ из раздела «Наилучшие оценки» из таблицы «Выбор коэффициентов развития». 
      В данной таблице можно выбрать паттерн из всех методов, которые были созданы для РУ. 
      При нажатии на название метода выбирается целиком соответствующий паттерн выплат.</p>
    <img src="@/assets/img/guide/dp-pattern-choose.png" alt="" srcset="">
    <p>Для других сущностей доступен выбор паттерна:</p>
    <ul>
      <li>на базе расчета резерва убытков</li>
      <li>на базе расчета соответствующей сущности</li>
    </ul>
    <img src="@/assets/img/guide/dp-pattern-reserv-choose.png" alt="" srcset="">
    <p>Данные также берутся из раздела «Наилучшие оценки» из таблицы «Выбор коэффициентов развития». В данных расчетах берутся все методы, созданные в разделе «Наилучшие оценки» кроме метода «Доля от резерва» так как в нем нет паттерна.</p>
    <p>4.	Прогноз будущих выплат </p>
    <p>Последние таблицы посвящены Прогнозу будущих выплат. В расчете представлено несколько видов таблиц:</p>
    <ul>
      <li>Прогноз будущих выплат по когортам (на рисунке это таблицы 6, 7, 8)</li>
    </ul>
    <p>Данные таблицы перемножают прогноз выручки (или прогноз состоявшихся убытков) по когорте, выбранную убыточность и выбранный паттерн выплат. Для расчета оплаченных убытков выбранная убыточность берется из респективных таблиц по когорте.</p>
    <ul>
      <li>Прогноз будущих выплат на Т = 0 (на рисунке это таблица 9)</li>
    </ul>
    <p>Данная таблица также перемножает прогноз выручки (или прогноз состоявшихся убытков) из Т = 0, выбранную убыточность и выбранный паттерн выплат. Для расчета оплаченных убытков выбранная убыточность берется из соответствующих таблиц по когорте.</p>
    <ul>
      <li>Прогноз будущих выплат по всем когортам (на рисунке это таблица 5)</li>
    </ul>
    <p>Данная таблица суммирует результаты полученных выплат по всем когортам.</p>
    <img src="@/assets/img/guide/dp-forecast.png" alt="" srcset="">
  </div>
  <div class="block">
    <h5>Месячные ДП ООЧП</h5>
    <p>1. Прогноз выручки</p>
    <p>Перед таблицами с расчетами на интерфейсе указаны версия расчета и прогноз выручки из загрузочного файла. Для месячных ДП ООЧП прогноз заработанной премии делится на действующий и новый типы бизнеса.</p>
    <img src="@/assets/img/guide/oocp-forecast-premium.png" alt="" srcset="">
    <p>Для остальных сущностей в начале каждого раздела отражается прогноз состоявшихся убытков вместо прогноза выручки, который считается на основе прогноза выручки из загрузки и коэффициентов убыточности по когортам из оплаченных убытков.</p>
    <img src="@/assets/img/guide/oocp-forecast-loss.png" alt="" srcset="">
    <p>2.	Коэффициенты убыточности</p>
    <p>Далее в расчетах по оплаченным убыткам рассчитываются коэффициенты убыточности по когорте. Для данных расчетов используется Заработная премия и окончательная убыточность из РУ из раздела «Наилучшие оценки».</p>
    <p>Пользователь может выбрать коэффициент убыточности по каждому периоду для каждой когорты, которая есть в загрузке для месячных ДП ООЧП. Доступны следующие опции:</p>
    <ul>
      <li>Средний за последний год  <i>(4 квартала)</i></li>
      <li>Средний за последние два года <i>(8 кварталов)</i></li>
      <li>Средний за последний год из итогового РУ</li>
      <li>Андеррайтинговый КУ из загрузки (используется загрузочный лист, где «Тип данных» является одним из следующих значений: «андеррайтинговые коэффициенты убыточности (для оплаченных убытков)», «андеррайтинговые коэффициенты убыточности (для урег. нул. треб.)», «андеррайтинговые коэффициенты убыточности (для расходов по разнице первичных требований и возмещений от РСА)».)</li>
      <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/oocp-loss-select.png" alt="" srcset="">
    <p>Для других сущностей рассчитывается «Выбор доли, %». В данную таблицу выгружаются методы, созданные в разделе «Наилучшие оценки» для каждой сущности. Для выбора коэффициентов доступны следующие опции:</p>
    <ul>
      <li>Средний за последний год <i>(4 квартала)</i></li>
      <li>Средний за последний год <i>(8 кварталов)</i></li>
      <li>За последний квартал</li>
      <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/share-select.png" alt="" srcset="">
    <p>3. Выбор паттерна</p>
    <p>Далее для всех сущностей выбирается паттерн, который рассчитывается с помощью факторов развития РУ из раздела «Наилучшие оценки» из таблицы «Выбор коэффициентов развития». В данной таблице можно выбрать паттерн из всех методов, которые были созданы для РУ. При нажатии на название метода выбирается целиком соответствующий паттерн выплат.</p>
    <img src="@/assets/img/guide/choose-pattern.png" alt="">
    <p>Для других сущностей доступен выбор паттерна:</p>
    <ul>
      <li>на базе расчета резерва убытков</li>
      <li>на базе расчета соответствующей сущности</li>
    </ul>
    <img src="@/assets/img/guide/choose-pattern-reserv.png" alt="" srcset="">
    <p>Данные также берутся из раздела «Наилучшие оценки» из таблицы «Выбор коэффициентов развития». В данных расчетах берутся все методы, созданные в разделе «Наилучшие оценки» кроме метода «Доля от резерва» так как в нем нет паттерна.</p>
    <p>4.	Месячный паттерн урегулирования</p>
    <p>Данная таблицы распределяет факторы развития из раздела «Наилучшие оценки» по месяцам на основе двух методов:</p>
    <ul>
      <li>Распределение по месяцам пропорционально времени</li>
      <li>Распределение по месяцам по линейной интерполяции</li>
    </ul>
    <p>В оплаченных убытках паттерн рассчитывается на базе расчета из Резерва убытков.</p>
    <img src="@/assets/img/guide/choose-pattern-month.png" alt="" srcset="">
    <p>В других сущностях помимо резерва убытков, также берется паттерн из соответствующих сущностей:</p>
    <p><i>Например, в РРУУ прям.</i></p>
    <img src="@/assets/img/guide/choose-pattern-month-reserv.png" alt="" srcset="">
    <p>В данных расчетах берутся все методы, созданные в разделе «Наилучшие оценки» кроме метода «Доля от резерва» так как в нем нет паттерна.</p>
    <p>5.	Прогноз будущих выплат</p>
    <p>Последние таблицы посвящены Прогнозу будущих выплат. В расчете представлено несколько фильтров:</p>
    <ul>
      <li>Когорта</li>
      <li>Тип бизнеса (действующий или новый)</li>
    </ul>
    <img src="@/assets/img/guide/revenue-forecast.png" alt="" srcset="">
    <h5>Заполнение шаблона ООЧП</h5>
    <h6>ДП ООЧП месячные</h6>
    <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ООЧП по в соответствие с выбором фильтров «Когорта» и «Тип бизнеса». Для отображения расчетов по сущностям в шаблоне требуется провести расчеты по данным сущностям в ДП.</p>
    <img src="@/assets/img/guide/oocp-template-month.png" alt="" srcset="">
    <h6>ДП ООЧП годовые</h6>
    <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ООЧП по тем когортам, которые были поданы в загрузочном файле. Для отображения расчетов по сущностям в шаблоне требуется провести расчеты по данным сущностям в ДП.</p>
    <img src="@/assets/img/guide/oocp-result-year.png" alt="" srcset="">
    <img src="@/assets/img/guide/oocp-result-year-detail.png" alt="" srcset="">
  </div>

  <div class="block">
    <h5>ДП ОВТ (по прямому бизнесу)</h5>
    <h6>Годовые ДП ОВТ</h6>
    <p>Расчеты в ДП ОВТ годовых проходят следующим образом:</p>
    <ol>
      <li>Берется инкрементальный треугольник из расчета (смотри «Персонализация расчетов»)</li>
      <li>На основе выбранного расчета выстраиваются факторы развития</li>
      <li>На основе факторов развития рассчитывается таблица «Доля урегулирования в периоде»</li>
      <li>На основе доли урегулирования рассчитывается таблица «Высвобождение по периодам»</li>
      <li>На основе выбранного резерва в разделе «Обзор результата» и высвобождения по периодам достраивается инкрементальный и кумулятивный треугольники</li>
      <li>На основе достроенного инкрементального треугольника рассчитываются ожидаемые потоки</li>
      <li>В таблице «Данные для аллокации»:
        <ul>
          <li>первая таблица подтягивает данные из загрузочного файла «ДП ОВТ годовые»</li>
          <li>вторая таблица рассчитывает коэффициенты распределения, используя данные для аллокации</li>
        </ul>
      </li>
    </ol>
    <p>В годовых расчетах по ДП ОВТ представлена возможность персонализировать свои расчеты с помощью фильтров.</p>
    <h6>Годовые ДП ОВТ</h6>
    <p>В годовых ДП ОВТ доступны следующие фильтры для персонализации расчетов:</p>
    <p>1.	Треугольник развития убытков из расчета (выбор треугольников из разных расчетов, созданных в разделе «Наилучшие оценки»)</p>
    <img src="@/assets/img/guide/triangle-select.png" alt="" srcset="">
    <p>2.	Используются факторы развития РУ по моменту (разные опции в зависимости от сущности)</p>
    <img src="@/assets/img/guide/factors-select.png" alt="" srcset="">
    <p>Для всех сущностей используются опции «Ручной ввод» и «Оплата убытков». Для некоторых сущностей есть дополнительные опции:</p>
    <ul>
      <li>РРУУ прям.: Понесения РУУ (прям.)</li>
      <li>РРУУ суд.: Понесения РУУ (судебн.)</li>
      <li>РРУУ ПВУ: Понесения РУУ (ПВУ)</li>
      <li>ГОТС: Возн. прав на ГОТС</li>
      <li>Регрессы: Возн. прав на регрессы</li>
    </ul>
    <p>3.	Драйвер для аллокации по когортам (выбор типа убытков для аллокации по когортам)</p>
    <img src="@/assets/img/guide/allocation-select.png" alt="" srcset="">
    <p>Первый фильтр («Треугольник развития убытков из расчета») позволяет выбрать треугольник развития убытков, на основе которого будут посчитаны денежные потоки по произошедшим, но неурегулированным убыткам. В данном фильтре представлены все треугольники по всем расчетам, созданным в разделе «Наилучшие оценки». Данный фильтр не появляется для сущностей, для которых не был загружен треугольник. В зависимости от выбранного расчета меняется инкрементальный и кумулятивный треугольники в ДП ОВТ (измененный треугольник можно посмотреть в таблице «Кумулятивный треугольник развития»).</p>
    <img src="@/assets/img/guide/triangle-dp.png" alt="" srcset="">
    <p>Второй фильтр предоставляет разные опции выборов факторов развития для каждой сущности, которые описаны ниже:</p>
    <ul>
      <li>Оплаченные убытки (Оплаты убытков, Ручной ввод)</li>
      <li>РРУУ прямые (Оплаты убытков, Понесения РРУУ прям., Ручной ввод)</li>
      <li>РРУУ судебные (Оплаты убытков, Понесения РРУУ прям., Понесения РРУУ суд., Ручной ввод)</li>
      <li>РРУУ прочие (Оплаты убытков, Понесения РРУУ проч., Понесения РРУУ прям., Ручной ввод)</li>
      <li>РРУУ косвенные (Оплаты убытков, Понесения РРУУ прям., Ручной ввод)</li>
      <li>Регрессы (Оплаты убытков, Возн. Прав на регрессы, Ручной ввод)</li>
      <li>ГОТС (Оплаты убытков, Возн. Прав на ГОТС, Ручной ввод)</li>
      <li>Нулевые требования (Оплаты убытков, Ручной ввод)</li>
      <li>РСА (Оплаты убытков, Ручной ввод)</li>
    </ul>
    <p>Для всех сущностей предусмотрена опция «Ручной ввод» для факторов развития. При выборе данной опции следует вручную указать факторы развития в таблице «Паттерн возникновения, ручной ввод».</p>
    <img src="@/assets/img/guide/dp-pattern-appearance.png" alt="" srcset="">
    <p>Результаты выбранных опций в данном фильтре можно посмотреть в таблице «Факторы развития», которая отображает факторы развития, которые будут использоваться в дальнейших расчетах.</p>
    <img src="@/assets/img/guide/dp-factors.png" alt="" srcset="">
    <p>Третий фильтр влияет на таблицу «Данные для аллокации по когортам». В нем доступны три опции:</p>
    <ul>
      <li>Заявленные убытки</li>
      <li>Оплаченные убытки</li>
      <li>Понесенные убытки</li>
    </ul>
    <p>Данный фильтр нужен для выбора драйвера, который будет использован для аллокации произошедших, но неурегулированных убытков по когортам. При выборе разных опций меняются суммы распределенных убытков.</p>
    <img src="@/assets/img/guide/allocation-data-cohorts.png" alt="" srcset="">
    <h6>Месячные ДП ОВТ</h6>
    <p>Расчеты в ДП ОВТ годовых проходят следующим образом:</p>
    <ol>
      <li>Берется инкрементальный треугольник из расчета (смотри «Персонализация расчетов»)</li>
      <li>На основе выбранного расчета выстраиваются факторы развития</li>
      <li>На основе факторов развития рассчитывается таблица «Доля урегулирования в периоде»</li>
      <li>На основе доли урегулирования рассчитывается таблица «Высвобождение по периодам»</li>
      <li>На основе выбранного резерва в разделе «Обзор результата» и таблицы «Высвобождения по периодам» достраивается инкрементальный и кумулятивный треугольники</li>
      <li>На основе достроенного инкрементального треугольника рассчитывается таблица «Ожидаемые потоки»</li>
      <li>В таблице «Данные для аллокации»:</li>
      <ul>
        <li>первая таблица подтягивает данные из загрузочного файла «ДП ОВТ годовые»</li>
        <li>вторая таблица рассчитывает коэффициенты распределения, используя данные для аллокации</li>
      </ul>
    </ol>
    <p>В годовых расчетах по ДП ОВТ представлена возможность персонализировать свои расчеты с помощью фильтров.</p>
    <h6>Персонализация расчетов</h6>
    <p>В годовых ДП ОВТ доступны следующие фильтры для персонализации расчетов:</p>
    <p>1.	Треугольник развития убытков из расчета (выбор треугольников из разных расчетов, созданных в разделе «Наилучшие оценки»)</p>
    <img src="@/assets/img/guide/triangle-select-ovt.png" alt="" srcset="">
    <p>2.	Используются факторы развития РУ по моменту (разные опции в зависимости от сущности)</p>
    <img src="@/assets/img/guide/factors-select-ovt.png" alt="" srcset="">
    <p>Для всех сущностей используются опции «Ручной ввод» и «Оплата убытков». Для некоторых сущностей есть дополнительные опции:</p>
    <ul>
      <li>РРУУ прям.: Понесения РУУ (прям.)</li>
      <li>РРУУ суд.: Понесения РУУ (судебн.)</li>
      <li>РРУУ ПВУ: Понесения РУУ (ПВУ)</li>
      <li>ГОТС: Возн. прав на ГОТС</li>
      <li>Регрессы: Возн. прав на регрессы</li>
    </ul>
    <p>3.	Драйвер для аллокации по когортам (выбор типа убытков для аллокации по когортам)</p>
    <img src="@/assets/img/guide/allocation-driver-cohorts-ovt.png" alt="" srcset="">
    <p>4.	Драйвер для разбивки РПНУ по месяцам возникновения</p>
    <img src="@/assets/img/guide/rpnu-driver-ovt.png" alt="" srcset="">
    <p>5.	Переход к месячному расчету высвобождения резерва</p>
    <img src="@/assets/img/guide/month-reserv-select-ovt.png" alt="" srcset="">
    <p>Первый фильтр («Треугольник развития убытков из расчета») позволяет выбрать треугольник развития убытков, на основе которого будут посчитаны денежные потоки по произошедшим, но неурегулированным убыткам. В данном фильтре представлены все треугольники по всем расчетам, созданных в разделе «Наилучшие оценки». Данный фильтр не появляется для сущностей, для которых не был загружен треугольник. В зависимости от выбранного расчета меняется инкрементальный и кумулятивный треугольники в ДП ОВТ (измененный треугольник можно посмотреть в таблице «Кумулятивный треугольник развития»).</p>
    <img src="@/assets/img/guide/triangle-dp.png" alt="" srcset="">
    <p>Второй фильтр («Используются факторы развития РУ по моменту») предоставляет разные опции выборов факторов развития для каждой сущности, которые описаны ниже:</p>
    <ul>
      <li>Оплаченные убытки (Оплаты убытков, Ручной ввод)</li>
      <li>РУУ прямые (Оплаты убытков, Понесения РУУ прям., Ручной ввод)</li>
      <li>РУУ судебные (Оплаты убытков, Понесения РУУ прям., Понесения РУУ суд., Ручной ввод)</li>
      <li>РУУ прочие (Оплаты убытков, Понесения РУУ проч., Понесения РУУ прям., Ручной ввод)</li>
      <li>РУУ косвенные (Оплаты убытков, Понесения РУУ прям., Ручной ввод)</li>
      <li>Регрессы (Оплаты убытков, Возн. Прав на регрессы, Ручной ввод)</li>
      <li>ГОТС (Оплаты убытков, Возн. Прав на ГОТС, Ручной ввод)</li>
      <li>Нулевые требования (Оплаты убытков, Ручной ввод)</li>
      <li>РСА (Оплаты убытков, Ручной ввод)</li>
    </ul>
    <p>Для всех сущностей предусмотрена опция «Ручной ввод» для факторов развития. При выборе данной опции следует вручную указать факторы развития в таблице «Паттерн возникновения, ручной ввод».</p>
    <img src="@/assets/img/guide/dp-pattern-appearance-arrow.png" alt="" srcset="">
    <p>Результаты выбранных опций в данном фильтре можно посмотреть в таблице «Факторы развития», которая отображает факторы развития, которые будут использоваться в дальнейших расчетах.</p>
    <img src="@/assets/img/guide/dp-factors.png" alt="" srcset="">
    <p>Третий фильтр влияет на таблицу «Данные для аллокации по когортам». В нем доступны три опции:</p>
    <ul>
      <li>Заявленные убытки</li>
      <li>Оплаченные убытки</li>
      <li>Понесенные убытки</li>
    </ul>
    <p>Данный фильтр нужен для выбора драйвера, который будет использован для аллокации произошедших, но неурегулированных убытков по когортам. При выборе разных опций меняются суммы распределенных убытков.</p>
    <img src="@/assets/img/guide/allocation-data-cohorts.png" alt="" srcset="">
    <p>Также, доступны расчеты по <b>текущему сервису.</b></p>
    <img src="@/assets/img/guide/allocation-data-current-service.png" alt="" srcset="">
    <p>Он влияет на построение таблицы «Высвобождение резерва по периодам».</p>
    <p>Четвертый фильтр «Драйвер для разбивки РПНУ по месяцам возникновения» необходим для того, чтобы экстраполировать резерв из квартального в месячный. Доступны следующие опции:</p>
    <ul>
      <li>Пропорционально выручке (берется из месячной загрузки ДП ОВТ)</li>
      <li>Пропорционально времени</li>
    </ul>
    <p>Данный фильтр меняет разбивку РПНУ, используя данные из раздела «обзор результата». Данный фильтр влияет на расчет достроенного треугольника.</p>
    <p>В пятом фильтре «Переход к месячному расчету высвобождения резерва» доступны следующие опции:</p>
    <ul>
      <li>Линейная интерполяция</li>
      <li>Пропорционально времени</li>
      <li>Ручной ввод</li>
    </ul>
  </div>
  <div class="block">
    <h5>Заполнение шаблона ДП по ОВТ</h5>
    <h6>Месячные ДП ОВТ</h6>
    <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ОВТ. В шаблоне представлены профили убытков по всем сущностям, рассчитанным раннее. Значения в расчетах зависят от фильтра «Драйвер для аллокации по когортам», который присутствует в каждой сущности. В месячных ДП ОВТ есть возможность выбрать когорту расчета:</p>
    <img src="@/assets/img/guide/ovt-template-cohort-selection.png" alt="">
    <h6>Годовые ДП ОВТ</h6>
    <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ОВТ. В шаблоне представлены профили убытков по всем сущностям рассчитанным раннее. Значения в расчетах зависят от фильтра «Драйвер для аллокации по когортам», который присутствует в каждой сущности. В годовых ОВТ убытки разбиты по андеррайтинговым годам.</p>
    <img src="@/assets/img/guide/ovt-template-by-years.png" alt="" srcset="">
  </div>
</template>
  
<script>
export default {
  name: 'CashflowsDirect',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
